// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4615bdb6","218":"d6a3eecc","488":"daacfcfc","586":"35b19393","593":"fcd64f61","662":"582e5867","892":"5cde83ed","906":"868a168b","912":"afc3df82","970":"a13b3218","979":"d6f3a323","992":"a92f5060"}[chunkId] + ".chunk.js";
};